var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#251163"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.207 5.91475L20.5 8.5H5.5L6.793 5.91475C6.85524 5.79019 6.95093 5.68542 7.06936 5.61216C7.18778 5.53891 7.32425 5.50007 7.4635 5.5H18.5365C18.6757 5.50007 18.8122 5.53891 18.9306 5.61216C19.0491 5.68542 19.1448 5.79019 19.207 5.91475ZM5.5 10H20.5V19.75C20.5 19.9489 20.421 20.1397 20.2803 20.2803C20.1397 20.421 19.9489 20.5 19.75 20.5H6.25C6.05109 20.5 5.86032 20.421 5.71967 20.2803C5.57902 20.1397 5.5 19.9489 5.5 19.75V10ZM7.75 17.5C7.75 17.6989 7.82902 17.8897 7.96967 18.0303C8.11032 18.171 8.30109 18.25 8.5 18.25H11.5C11.6989 18.25 11.8897 18.171 12.0303 18.0303C12.171 17.8897 12.25 17.6989 12.25 17.5C12.25 17.3011 12.171 17.1103 12.0303 16.9697C11.8897 16.829 11.6989 16.75 11.5 16.75H8.5C8.30109 16.75 8.11032 16.829 7.96967 16.9697C7.82902 17.1103 7.75 17.3011 7.75 17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkid);
export default __webpack_public_path__ + "static/media/skid.b0faf843cb791b5730b6341f679772ef.svg";
export { ForwardRef as ReactComponent };